import { render, staticRenderFns } from "./PerformanceFeeTable.vue?vue&type=template&id=4243b48a&scoped=true&"
import script from "./PerformanceFeeTable.vue?vue&type=script&lang=js&"
export * from "./PerformanceFeeTable.vue?vue&type=script&lang=js&"
import style0 from "./PerformanceFeeTable.vue?vue&type=style&index=0&id=4243b48a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4243b48a",
  null
  
)

export default component.exports